/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateParameterGroup {
    getFixupPrototypeFunction() { return TemplateParameterGroup.fixupPrototype; }

    static newInstance(model: Partial<TemplateParameterGroup>): TemplateParameterGroup {
        let obj = Object.assign(new TemplateParameterGroup(), model);
        TemplateParameterGroup.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateParameterGroup>): TemplateParameterGroup {
        if (!model) return null;
        return TemplateParameterGroup.newInstance(<TemplateParameterGroup> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateParameterGroup) {
        if (!obj) return;

        models.TemplateParameterGroup.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateParameterGroup): boolean {
        Object.setPrototypeOf(obj, TemplateParameterGroup.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Group heading shown in the UI
     */
    label: string;

    /**
     * What this group of parameters covers
     */
    description: string;

    /**
     * Names of the parameters in this group, in display order. Each name matches a 'params' entry
     */
    parameters: Array<string>;

}
